// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Wrapper ── */
.table-secondary-topbar-wrap {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  z-index: 100;
}

.table-secondary-topbar {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 8px;
  display: flex;
  align-items: center;
  gap: 0;
  justify-content: space-between;
}

/* ════════════════════════════════════
   LEFT — filter chips
════════════════════════════════════ */
.stb-left {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

/* "All" light blue pill (active) */
.stb-all-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px 5px 6px;
  border-radius: 999px;
  border: 1px solid #bfdbfe;
  background: #edf5ff;
  color: #2563eb;
  font-size: 0.813rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.12s;
}

.stb-all-pill:not(.active) {
  background: #f1f5f9;
  border: 1px solid transparent;
  color: #64748b;
}

.stb-all-pill:not(.active):hover {
  background: #e2e8f0;
  color: #1e293b;
}

.stb-all-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #bfdbfe;
  color: #2563eb;
  font-size: 0.7rem;
  font-weight: 800;
  flex-shrink: 0;
}

.stb-all-pill:not(.active) .stb-all-avatar {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #64748b;
}

/* Thin separator between "All" and filter items */
.stb-separator {
  width: 1px;
  height: 18px;
  background: #e2e8f0;
  margin: 0 10px;
  flex-shrink: 0;
}

/* Available / Occupied / Payment — plain text + dot */
.stb-filter-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid transparent;
  background: transparent;
  font-size: 0.813rem;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  white-space: nowrap;
  border-radius: 999px;
  transition: all 0.12s;
}

.stb-filter-item:hover {
  color: #1e293b;
  background: #f1f5f9;
}

.stb-filter-item.active {
  color: #334155;
  font-weight: 600;
  background: #ffffff;
  border: 1px solid #cbd5e1;
}

.stb-filter-item.stb-filter-item--occupied.active {
  background: #e6fcf5;
  border-color: #a7f3d0;
  color: #047857;
}

.stb-filter-item.stb-filter-item--payment.active {
  background: #fffbeb;
  border-color: #fde68a;
  color: #d97706;
}

/* Colored dots */
.stb-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.stb-dot--available {
  background: transparent;
  border: 1.5px solid #94a3b8;
}

.stb-dot--occupied {
  background: #10b981;
}
.stb-dot--payment {
  background: #f59e0b;
}

/* ════════════════════════════════════
   MIDDLE — Merge / Split / Floor
════════════════════════════════════ */
.stb-middle {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0 auto;
  flex-shrink: 0;
}

.stb-action-group {
  display: flex;
  align-items: center;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.8);
  padding: 2px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(8px);
}

.stb-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-weight: 500;
  transition:
    background-color 0.2s,
    border-color 0.2s,
    color 0.2s;
  border: 1px solid transparent;
  min-height: 32px;
  height: 32px;
  border-radius: 8px;
  padding: 0 8px;
  font-size: 12px;
  color: #334155;
  background: transparent;
  cursor: pointer;
}

.stb-action-btn:hover {
  background-color: #f1f5f9;
  color: #334155;
}

.stb-action-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px #94a3b8;
}

.stb-action-btn:disabled {
  pointer-events: none;
  opacity: 0.5;
}

.stb-action-btn svg {
  pointer-events: none;
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  margin-right: 6px;
}

.stb-floor-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid #dde5f0;
  background: #fff;
  font-size: 0.813rem;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: all 0.12s;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.stb-floor-btn:hover,
.stb-floor-btn.active {
  /* background: #edf3ff; */
  color: #1d4ed8;
  border-color: #cfe0ff;
}

/* ════════════════════════════════════
   RIGHT — sale modes (segmented pill)
════════════════════════════════════ */
.stb-right {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 3px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
}

.stb-mode-btn {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 999px;
  border: 1.5px solid transparent;
  background: transparent;
  font-size: 0.813rem;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.12s;
}

.stb-mode-btn:hover {
  color: #1e293b;
}

.stb-mode-btn.active {
  border-color: #bfdbfe;
  color: #2563eb;
  font-weight: 700;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(37, 99, 235, 0.08);
}

/* ════════════════════════════════════
   Floor dropdown panel
════════════════════════════════════ */
.secondary-topbar-floor-row {
  position: absolute;
  top: calc(100% - 2px);
  right: 22px;
  z-index: 30;
}

.secondary-topbar-floor-tabs-wrap {
  position: relative;
  display: inline-flex;
}

.secondary-topbar-floor-tabs-wrap.can-scroll-right::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 56px;
  height: 100%;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.97) 72%);
  border-radius: 0 20px 20px 0;
  pointer-events: none;
  z-index: 1;
}

.secondary-topbar-floor-tabs-wrap.can-scroll-right::before {
  content: "›";
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  color: #62748c;
  pointer-events: none;
  z-index: 2;
}

.secondary-topbar-floor-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 20px;
  padding: 8px;
  border: 1px solid #dde5f0;
  box-shadow: 0 10px 24px rgba(73, 90, 121, 0.12);
  overflow-x: auto;
  max-width: min(78vw, 720px);
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.secondary-topbar-floor-tabs::-webkit-scrollbar {
  display: none;
}

.secondary-topbar-floor-tab {
  border: none;
  background: transparent;
  color: #62748c;
  font-size: 0.9rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.secondary-topbar-floor-tab:hover {
  color: #111827;
}

.secondary-topbar-floor-tab.active {
  background: #edf3ff;
  color: #2463eb;
  font-weight: 800;
}

.secondary-topbar-floor-tab:disabled {
  opacity: 0.6;
  cursor: wait;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .table-secondary-topbar {
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 14px;
  }

  .stb-left {
    flex-wrap: wrap;
    gap: 4px;
  }
  .stb-middle {
    margin: 0;
  }
  .stb-right {
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .table-secondary-topbar {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    padding: 8px 10px;
  }

  .stb-left,
  .stb-middle,
  .stb-right {
    width: 100%;
    justify-content: flex-start;
  }
}

.stb-last-length {
  display: flex;
  justify-content: center;
  align-items: ceter;
  gap: 5px;
}

/* ═══ DARK THEME — SecondaryTopbar ═══ */
.dark .table-secondary-topbar {
  background: #1e293b;
  border-bottom-color: #334155;
}

.dark .stb-all-pill:not(.active) {
  background: #334155;
  color: #94a3b8;
}
.dark .stb-all-pill:not(.active):hover { background: #475569; color: #e2e8f0; }
.dark .stb-all-avatar { background: #1e293b; border-color: #475569; }
.dark .stb-all-pill:not(.active) .stb-all-avatar { background: #1e293b; border-color: #334155; color: #94a3b8; }

.dark .stb-separator { background: #334155; }

.dark .stb-filter-item { color: #64748b; }
.dark .stb-filter-item:hover { color: #e2e8f0; background: #334155; }
.dark .stb-filter-item.active { background: #1e293b; border-color: #475569; color: #e2e8f0; }

.dark .stb-action-group {
  background: rgba(30,41,59,0.9);
  border-color: rgba(71,85,105,0.6);
}
.dark .stb-action-btn { color: #94a3b8; }
.dark .stb-action-btn:hover { background-color: #334155; color: #e2e8f0; }

.dark .stb-floor-btn {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .stb-floor-btn:hover, .dark .stb-floor-btn.active { color: #60a5fa; border-color: #1d4ed8; }

.dark .stb-right {
  background: #0f172a;
  border-color: #334155;
}
.dark .stb-mode-btn { color: #64748b; }
.dark .stb-mode-btn:hover { color: #e2e8f0; }
.dark .stb-mode-btn.active {
  background: #1e293b;
  border-color: #334155;
  color: #60a5fa;
}

.dark .secondary-topbar-floor-tabs {
  background: rgba(15,23,42,0.97);
  border-color: #334155;
}
.dark .secondary-topbar-floor-tabs-wrap.can-scroll-right::after {
  background: linear-gradient(to right, transparent, rgba(15,23,42,0.97) 72%);
}
.dark .secondary-topbar-floor-tabs-wrap.can-scroll-right::before { color: #64748b; }
.dark .secondary-topbar-floor-tab { color: #64748b; }
.dark .secondary-topbar-floor-tab:hover { color: #e2e8f0; }
.dark .secondary-topbar-floor-tab.active { background: #1e3a8a; color: #93c5fd; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/components/SecondaryTopbar/SecondaryTopbar.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,8BAA8B;AAChC;;AAEA;;sCAEsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;;sCAEsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,YAAY;EACZ,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB;;;cAGY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;sCAEsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;sCAEsC;AACtC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,4BAA4B;EAC5B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,+CAA+C;EAC/C,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;IACf,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;;;IAGE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,yCAAyC,mBAAmB,EAAE,cAAc,EAAE;AAC9E,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE;AACpE,mDAAmD,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAE/G,uBAAuB,mBAAmB,EAAE;;AAE5C,yBAAyB,cAAc,EAAE;AACzC,+BAA+B,cAAc,EAAE,mBAAmB,EAAE;AACpE,gCAAgC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAE5F;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA,wBAAwB,cAAc,EAAE;AACxC,8BAA8B,yBAAyB,EAAE,cAAc,EAAE;;AAEzE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,0DAA0D,cAAc,EAAE,qBAAqB,EAAE;;AAEjG;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,sBAAsB,cAAc,EAAE;AACtC,4BAA4B,cAAc,EAAE;AAC5C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,2EAA2E;AAC7E;AACA,mEAAmE,cAAc,EAAE;AACnF,oCAAoC,cAAc,EAAE;AACpD,0CAA0C,cAAc,EAAE;AAC1D,2CAA2C,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":["/* ── Wrapper ── */\n.table-secondary-topbar-wrap {\n  position: fixed;\n  top: 56px;\n  left: 0;\n  right: 0;\n  z-index: 100;\n}\n\n.table-secondary-topbar {\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 8px 8px;\n  display: flex;\n  align-items: center;\n  gap: 0;\n  justify-content: space-between;\n}\n\n/* ════════════════════════════════════\n   LEFT — filter chips\n════════════════════════════════════ */\n.stb-left {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n/* \"All\" light blue pill (active) */\n.stb-all-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px 5px 6px;\n  border-radius: 999px;\n  border: 1px solid #bfdbfe;\n  background: #edf5ff;\n  color: #2563eb;\n  font-size: 0.813rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.12s;\n}\n\n.stb-all-pill:not(.active) {\n  background: #f1f5f9;\n  border: 1px solid transparent;\n  color: #64748b;\n}\n\n.stb-all-pill:not(.active):hover {\n  background: #e2e8f0;\n  color: #1e293b;\n}\n\n.stb-all-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #ffffff;\n  border: 1px solid #bfdbfe;\n  color: #2563eb;\n  font-size: 0.7rem;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.stb-all-pill:not(.active) .stb-all-avatar {\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  color: #64748b;\n}\n\n/* Thin separator between \"All\" and filter items */\n.stb-separator {\n  width: 1px;\n  height: 18px;\n  background: #e2e8f0;\n  margin: 0 10px;\n  flex-shrink: 0;\n}\n\n/* Available / Occupied / Payment — plain text + dot */\n.stb-filter-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid transparent;\n  background: transparent;\n  font-size: 0.813rem;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  white-space: nowrap;\n  border-radius: 999px;\n  transition: all 0.12s;\n}\n\n.stb-filter-item:hover {\n  color: #1e293b;\n  background: #f1f5f9;\n}\n\n.stb-filter-item.active {\n  color: #334155;\n  font-weight: 600;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n}\n\n.stb-filter-item.stb-filter-item--occupied.active {\n  background: #e6fcf5;\n  border-color: #a7f3d0;\n  color: #047857;\n}\n\n.stb-filter-item.stb-filter-item--payment.active {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #d97706;\n}\n\n/* Colored dots */\n.stb-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.stb-dot--available {\n  background: transparent;\n  border: 1.5px solid #94a3b8;\n}\n\n.stb-dot--occupied {\n  background: #10b981;\n}\n.stb-dot--payment {\n  background: #f59e0b;\n}\n\n/* ════════════════════════════════════\n   MIDDLE — Merge / Split / Floor\n════════════════════════════════════ */\n.stb-middle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0 auto;\n  flex-shrink: 0;\n}\n\n.stb-action-group {\n  display: flex;\n  align-items: center;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  background: rgba(255, 255, 255, 0.8);\n  padding: 2px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  backdrop-filter: blur(8px);\n}\n\n.stb-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-weight: 500;\n  transition:\n    background-color 0.2s,\n    border-color 0.2s,\n    color 0.2s;\n  border: 1px solid transparent;\n  min-height: 32px;\n  height: 32px;\n  border-radius: 8px;\n  padding: 0 8px;\n  font-size: 12px;\n  color: #334155;\n  background: transparent;\n  cursor: pointer;\n}\n\n.stb-action-btn:hover {\n  background-color: #f1f5f9;\n  color: #334155;\n}\n\n.stb-action-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 1px #94a3b8;\n}\n\n.stb-action-btn:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.stb-action-btn svg {\n  pointer-events: none;\n  flex-shrink: 0;\n  width: 14px;\n  height: 14px;\n  margin-right: 6px;\n}\n\n.stb-floor-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  border: 1px solid #dde5f0;\n  background: #fff;\n  font-size: 0.813rem;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.12s;\n  white-space: nowrap;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.stb-floor-btn:hover,\n.stb-floor-btn.active {\n  /* background: #edf3ff; */\n  color: #1d4ed8;\n  border-color: #cfe0ff;\n}\n\n/* ════════════════════════════════════\n   RIGHT — sale modes (segmented pill)\n════════════════════════════════════ */\n.stb-right {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 999px;\n  padding: 3px;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.stb-mode-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 10px;\n  border-radius: 999px;\n  border: 1.5px solid transparent;\n  background: transparent;\n  font-size: 0.813rem;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.12s;\n}\n\n.stb-mode-btn:hover {\n  color: #1e293b;\n}\n\n.stb-mode-btn.active {\n  border-color: #bfdbfe;\n  color: #2563eb;\n  font-weight: 700;\n  background: #ffffff;\n  box-shadow: 0 1px 4px rgba(37, 99, 235, 0.08);\n}\n\n/* ════════════════════════════════════\n   Floor dropdown panel\n════════════════════════════════════ */\n.secondary-topbar-floor-row {\n  position: absolute;\n  top: calc(100% - 2px);\n  right: 22px;\n  z-index: 30;\n}\n\n.secondary-topbar-floor-tabs-wrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.secondary-topbar-floor-tabs-wrap.can-scroll-right::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 56px;\n  height: 100%;\n  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.97) 72%);\n  border-radius: 0 20px 20px 0;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.secondary-topbar-floor-tabs-wrap.can-scroll-right::before {\n  content: \"›\";\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1;\n  color: #62748c;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.secondary-topbar-floor-tabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(255, 255, 255, 0.96);\n  border-radius: 20px;\n  padding: 8px;\n  border: 1px solid #dde5f0;\n  box-shadow: 0 10px 24px rgba(73, 90, 121, 0.12);\n  overflow-x: auto;\n  max-width: min(78vw, 720px);\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.secondary-topbar-floor-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.secondary-topbar-floor-tab {\n  border: none;\n  background: transparent;\n  color: #62748c;\n  font-size: 0.9rem;\n  font-weight: 700;\n  border-radius: 999px;\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.secondary-topbar-floor-tab:hover {\n  color: #111827;\n}\n\n.secondary-topbar-floor-tab.active {\n  background: #edf3ff;\n  color: #2463eb;\n  font-weight: 800;\n}\n\n.secondary-topbar-floor-tab:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .table-secondary-topbar {\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 10px 14px;\n  }\n\n  .stb-left {\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n  .stb-middle {\n    margin: 0;\n  }\n  .stb-right {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 480px) {\n  .table-secondary-topbar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 6px;\n    padding: 8px 10px;\n  }\n\n  .stb-left,\n  .stb-middle,\n  .stb-right {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n.stb-last-length {\n  display: flex;\n  justify-content: center;\n  align-items: ceter;\n  gap: 5px;\n}\n\n/* ═══ DARK THEME — SecondaryTopbar ═══ */\n.dark .table-secondary-topbar {\n  background: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dark .stb-all-pill:not(.active) {\n  background: #334155;\n  color: #94a3b8;\n}\n.dark .stb-all-pill:not(.active):hover { background: #475569; color: #e2e8f0; }\n.dark .stb-all-avatar { background: #1e293b; border-color: #475569; }\n.dark .stb-all-pill:not(.active) .stb-all-avatar { background: #1e293b; border-color: #334155; color: #94a3b8; }\n\n.dark .stb-separator { background: #334155; }\n\n.dark .stb-filter-item { color: #64748b; }\n.dark .stb-filter-item:hover { color: #e2e8f0; background: #334155; }\n.dark .stb-filter-item.active { background: #1e293b; border-color: #475569; color: #e2e8f0; }\n\n.dark .stb-action-group {\n  background: rgba(30,41,59,0.9);\n  border-color: rgba(71,85,105,0.6);\n}\n.dark .stb-action-btn { color: #94a3b8; }\n.dark .stb-action-btn:hover { background-color: #334155; color: #e2e8f0; }\n\n.dark .stb-floor-btn {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .stb-floor-btn:hover, .dark .stb-floor-btn.active { color: #60a5fa; border-color: #1d4ed8; }\n\n.dark .stb-right {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .stb-mode-btn { color: #64748b; }\n.dark .stb-mode-btn:hover { color: #e2e8f0; }\n.dark .stb-mode-btn.active {\n  background: #1e293b;\n  border-color: #334155;\n  color: #60a5fa;\n}\n\n.dark .secondary-topbar-floor-tabs {\n  background: rgba(15,23,42,0.97);\n  border-color: #334155;\n}\n.dark .secondary-topbar-floor-tabs-wrap.can-scroll-right::after {\n  background: linear-gradient(to right, transparent, rgba(15,23,42,0.97) 72%);\n}\n.dark .secondary-topbar-floor-tabs-wrap.can-scroll-right::before { color: #64748b; }\n.dark .secondary-topbar-floor-tab { color: #64748b; }\n.dark .secondary-topbar-floor-tab:hover { color: #e2e8f0; }\n.dark .secondary-topbar-floor-tab.active { background: #1e3a8a; color: #93c5fd; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
